import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import { Legislation } from "@/models/legislation/Legislation";

interface LegislationTableState {
  data: Legislation[];
  search: string;
  searchTags: string[];
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
  navigateBack: boolean;
  setNavigateBack: (navigateBack: boolean) => void;
  setTableState: (state: Partial<LegislationTableState>) => void;
  resetTableState: () => void;
}

const sessionStorageImpl = {
  getItem: (name: string): string | null => {
    if (typeof window === "undefined") return null;
    return sessionStorage.getItem(name);
  },
  setItem: (name: string, value: string): void => {
    if (typeof window === "undefined") return;
    sessionStorage.setItem(name, value);
  },
  removeItem: (name: string): void => {
    if (typeof window === "undefined") return;
    sessionStorage.removeItem(name);
  },
};

export const useLegislationTableStore = create<LegislationTableState>()(
  persist(
    (set) => ({
      data: [],
      search: "",
      searchTags: [],
      pageCount: 0,
      pageIndex: 0,
      pageSize: 20,
      sorting: [],
      columnFilters: [],
      navigateBack: false,
      setNavigateBack: (navigateBack: boolean) => set({ navigateBack }),
      setTableState: (state) => set((prev) => ({ ...prev, ...state })),
      resetTableState: () =>
        set({
          data: [],
          search: "",
          searchTags: [],
          pageCount: 0,
          pageIndex: 0,
          pageSize: 20,
          sorting: [],
          columnFilters: [],
          navigateBack: false,
        }),
    }),
    {
      name: "legislation-table-state",
      storage: createJSONStorage(() => sessionStorageImpl),
      partialize: (state) => ({
        columnFilters: state.columnFilters,
        search: state.search,
        searchTags: state.searchTags,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        sorting: state.sorting,
      }),
    }
  )
);
